import Vue from 'vue'

import Vuetify from 'vuetify/lib'
// locale
import es from '@/locale/es'
import en from '@/locale/en'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { en, es },
    current: 'en'
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        //primary: '#ee44aa',
        primary: '#eC4724',
        //secondary: '#424242',
        secondary: '#A0B9C8',
        accent: '#82B1FF',
        //error: '#FF5252',
        error: '#EF476F',
        info: '#2196F3',
        //success: '#4CAF50',
        success: '#06D6A0',
        //warning: '#FFC107',
        warning: '#FFD166',
        canary: '#ffe300'
      }
    }
  }
})